import removeHtmlTags from "@/shared/helpers/removeHtmlTags";
import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";

export interface IPropertyDetailDescription {
  en: string;
  es: string;
  rawEn: string;
  rawEs: string;
}

const CLEAN_HTML_TAGS_REGEX = /<[^>]*>/g;
const HTML_LINE_BREAK_REGEX = /<(br|\/p|p)[^>]*>/gi;
const HTML_ENTITY_MAPPINGS: Record<string, string> = {
  "&nbsp;": " ",
  "&amp;": "&",
  "&lt;": "<",
  "&gt;": ">",
  "&quot;": '"',
  "&#39;": "'"
};

const decodeHtmlEntities = (input: string): string => {
  return Object.entries(HTML_ENTITY_MAPPINGS).reduce((acc, [entity, value]) => {
    return acc.replace(new RegExp(entity, "gi"), value);
  }, input);
};

const stripHtml = (input: string): string => {
  if (!input) {
    return "";
  }

  const withBreaks = input.replace(HTML_LINE_BREAK_REGEX, "\n");
  const withoutTags = withBreaks.replace(CLEAN_HTML_TAGS_REGEX, " ");
  const decoded = decodeHtmlEntities(withoutTags);

  const normalizedLines = decoded
    .split("\n")
    .map(line => line.replace(/\s+/g, " ").trim())
    .filter(Boolean);

  return normalizedLines.join("\n");
};

export const prepareDetailPropertyDescription = (
  data: IPropertyDetailsResponse
): IPropertyDetailDescription => {
  const rawEn = data?.info?.[1]?.description ?? "";
  const rawEs = data?.info?.[0]?.description ?? data?.description ?? "";

  return {
    en: rawEn,
    es: rawEs,
    rawEn: removeHtmlTags(rawEn),
    rawEs: removeHtmlTags(rawEs)
  };
};
